import { TextField } from "@mui/material";
import { useContext } from "react";

import Context from "../../context";
import ContextTable from "../../TransactionsTable/contextTable";
import useGetManageCompanies from "../service/useGetManageCompanies";

export default function CifNullFilter() {
	const { actions, state } = useContext(Context);
	const { onChangePage } = useContext(ContextTable);
	const { getManageCompanies } = useGetManageCompanies();

	const onChange = (value: string) => {
		actions.onChangeNullCifOnly(value === "Cif null");
		getManageCompanies(0, state.term, value === "Cif null", () => onChangePage(null, 0));
	};

	return (
		<TextField
			SelectProps={{ native: true }}
			fullWidth
			label='Tiene Cif?'
			onChange={(e) => onChange(e.target.value)}
			select
			size='small'
			sx={{ width: 200 }}
			value={state.nullCifOnly ? "Cif null" : "Todos los cifs"}
		>
			{["Todos los cifs", "Cif null"].map((option, index) => (
				<option key={index} value={option}>
					{option}
				</option>
			))}
		</TextField>
	);
}
